import { DateTime } from "luxon";

import type { OrderAuditEvent } from "@/schemas";

export const parseIsoMillis = (iso: string): number | null => {
	const dt = DateTime.fromISO(iso);
	return dt.isValid ? dt.toMillis() : null;
};

export const getLatestEvent = (events: OrderAuditEvent[]): OrderAuditEvent | null => {
	if (events.length === 0) {
		return null;
	}

	return events.reduce<OrderAuditEvent | null>((latest, current) => {
		const currentMillis = parseIsoMillis(current.eventDate);

		// Skip invalid dates
		if (currentMillis === null) {
			return latest;
		}

		// If no latest yet, use current
		if (latest === null) {
			return current;
		}

		const latestMillis = parseIsoMillis(latest.eventDate);

		// If latest is invalid, use current
		if (latestMillis === null) {
			return current;
		}

		// Return the event with the later timestamp
		return currentMillis > latestMillis ? current : latest;
	}, null);
};
